<template>
  <div
    id="account-sidebar"
    class="tw-relative md:tw-static tw-max-w-[246px] tw-mx-auto md:tw-mt-16"
  >
    <nav
      class="sidebar tw-absolute tw-bg-white md:tw-static md:tw-h-screen md:tw-pt-8 lg:tw-pt-0 tw-w-full tw-px-4 tw-z-10"
    >
      <div class="tw-border-b tw-border-[#F0F4FD] tw-pb-5">
        <h1
          class="tw-text-[#4C5B90] tw-text-[13px] tw-mb-2 tw-font-normal tw-leading-5"
        >
          ACCOUNT
        </h1>
        <AccountMenu title="Company Information" routeName="CompanyInfo" />
        <AccountMenu
          title="Identity Verification"
          routeName="IdentityVerification"
        />
        <AccountMenu title="Profile Summary" routeName="ProfileSummary" />
        <AccountMenu title="Manage Features" routeName="ManageFeatures" />
        <AccountMenu title="Manage Bank" routeName="ManageBank" />
      </div>
      <div class="tw-border-b tw-border-[#F0F4FD] tw-pb-5">
        <h1
          class="tw-text-[#4C5B90] tw-text-[13px] tw-mb-2 tw-font-normal tw-leading-5 tw-mt-8"
        >
          ORGANIZATION
        </h1>
        <AccountMenu title="Founders' Information" routeName="FounderInfo" />
        <AccountMenu title="Company Updates" routeName="CompanyUpdate" />
      </div>
      <div class="tw-border-b tw-border-[#F0F4FD] tw-pb-5">
        <h1
          class="tw-text-[#4C5B90] tw-text-[13px] tw-mb-2 tw-font-normal tw-leading-5 tw-mt-8"
        >
          SECURITY & PRIVACY
        </h1>
        <AccountMenu title="Login & Security" routeName="Security" />
      </div>
      <!-- <div class="tw-border-b tw-border-[#F0F4FD] tw-pb-5"> -->
        <!-- <h1
          class="tw-text-[#4C5B90] tw-text-[13px] tw-mb-2 tw-font-normal tw-leading-5 tw-mt-8"
        >
          CONTACT
        </h1> -->
        <!-- <AccountMenu title="Live Chat" @clicked="$emit('show-live-chat')" /> -->
      <!-- </div> -->
      <!-- <AccountMenu
        title="Security"
        :focus="security"
        @clicked="switchContent"
      /> -->
      <!-- <AccountMenu
        v-if="orgDetails.type !== 'Community'"
        title="Subscription Plans"
        :focus="subscriptionPlans"
        @clicked="switchContent"
      /> -->
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AccountMenu from "@/components/navigation/AccountMenu.vue";

export default {
  name: "AccountSidebar",
  components: { AccountMenu },
  emits: ["closeMenu", "switchLayout", "show-live-chat"],

  props: {
    focus: { type: String, default: () => "" },
  },
  data() {
    return {
      personalInformation: false,
      kycDocuments: false,
      bankInformation: false,
      security: false,
      subscriptionPlans: false,
      configuration: false,
      title: "Personal Information",
    };
  },
  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
    }),
  },
  created() {
    this.setFocus();
  },
  methods: {
    switchContent(title) {
      this.title = title;
      this.$emit("closeMenu");
      this.$emit("switchLayout", title);
      this.setFocus();
    },
    setFocus() {
      this.personalInformation = false;
      this.kycDocuments = false;
      this.bankInformation = false;
      this.security = false;
      this.subscriptionPlans = false;
      this.configuration = false;
      switch (this.title) {
        case "Personal Information":
          this.personalInformation = true;
          break;
        case "KYC Documents":
          this.kycDocuments = true;
          break;
        case "Bank Information":
          this.bankInformation = true;
          break;
        case "Security":
          this.security = true;
          break;
        case "Subscription Plans":
          this.subscriptionPlans = true;
          break;
        case "Configurations":
          this.configuration = true;
          break;
        default:
          break;
      }
    },
  },
  watch: {
    focus(oldValue, newValue) {
      if (oldValue !== newValue) {
        this.title = this.focus;
        this.setFocus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#account-sidebar {
  @include fadeIn;
}
</style>
